import { Swiper, Navigation, Mousewheel } from "swiper";
import { fetchSnap } from "../common/utils";

import SnapCardRenderer from "../common/snap-card-renderer";
const snapCardRenderer = SnapCardRenderer();

import ModalSnap from "../sections/modal-2023-snap";
const modalSnap = ModalSnap();

const renderBrandSnaps = (section) => {
  if (section.snapIds.length <= 0) {
    renderSnaps(section, []);
    return;
  }
  const params = {
    articleIds: section.snapIds,
  };
  fetchSnap(params)
    .then((response) => {
      if (!window.fstore.mediaCache) {
        window.fstore.mediaCache = {};
      }
      if (!window.fstore.mediaCache.snaps) {
        window.fstore.mediaCache.snaps = [];
      }
      window.fstore.mediaCache.snaps = window.fstore.mediaCache.snaps.concat(response);
      renderSnaps(section, response);
    })
    .catch((error) => {});
};

const renderSnaps = (section, snaps) => {
  if (snaps.length <= 0) {
    const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
    sectionElement.style.display = "none";
    return;
  }
  const items = snaps.map((snap) => {
    const item = snapCardRenderer.renderSnap(snap);
    return `<div class="swiper-slide">${item}</div>`;
  });

  const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
  const swiperElement = sectionElement.querySelector(".swiper");
  const wrapperElement = swiperElement.querySelector(".swiper-wrapper");
  wrapperElement.innerHTML = items.join("");

  wrapperElement.querySelectorAll(".fs-snap-card a").forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      modalSnap.showModalSnap(a.dataset["articleId"]);
    });
  });

  section.swiper = new Swiper(swiperElement, {
    modules: [Navigation, Mousewheel],
    centerInsufficientSlides: true,
    speed: 300,
    slidesPerView: 2.4,
    slidesPerGroup: 1,
    spaceBetween: 8,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 0.1,
      thresholdDelta: 10,
    },
    navigation: {
      nextEl: sectionElement.querySelector(".fs-swiper-navigation-next"),
      prevEl: sectionElement.querySelector(".fs-swiper-navigation-prev"),
    },
    breakpoints: {
      992: {
        speed: 900,
        slidesPerView: 6.4,
        slidesPerGroup: 6,
        spaceBetween: 8,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },
      1298: {
        speed: 900,
        slidesPerView: 4.75,
        slidesPerGroup: 4,
        spaceBetween: 8,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },
    },
  });
};

const mediaSliderSnapsMain = () => {
  if (!window.fstore.sections) {
    return;
  }
  window.fstore.sections.forEach((section) => {
    if (section.sectionType == "media-slider-snaps-brand") {
      renderBrandSnaps(section);
    }
  });
};

addEventListener("DOMContentLoaded", (event) => {
  mediaSliderSnapsMain();
});
